import { render, staticRenderFns } from "./Home.create-global-offer.vue?vue&type=template&id=df6f412e&"
import script from "./Home.create-global-offer.vue?vue&type=script&lang=js&"
export * from "./Home.create-global-offer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports